import { AUTOMATIC_SUPPORTED_UNITS } from '@schuettflix/interfaces';

type GetSellerProductPurchasePriceParams = {
    /** Catalogue price of the seller product as returned by the monolith (a decimal string, per ton). */
    price: string | null | undefined;
    purchaseMaterialUnit: AUTOMATIC_SUPPORTED_UNITS | undefined;
};

/**
 * Resolves the purchase material price that should be prefilled after a seller product was selected.
 * Catalogue prices are always per ton, so they only apply while the purchase material unit is TON.
 * Returns `undefined` when the price must not be touched.
 */
export function getSellerProductPurchasePrice({
    price,
    purchaseMaterialUnit,
}: GetSellerProductPurchasePriceParams): number | undefined {
    if (purchaseMaterialUnit !== 'TON') {
        return undefined;
    }

    if (price === null || price === undefined || price.trim() === '') {
        return undefined;
    }

    const parsed = Number(price);

    return Number.isFinite(parsed) ? parsed : undefined;
}
